import React from 'react';
import { Modal, Form, Row, Col, Table, Tabs, Tab, Spinner, Card } from 'react-bootstrap';
import { useQuery } from 'react-query';
import * as moment from 'moment';
import { Get } from '@app/utils/httpProvider';
import { 
    HOSO_TUYENSINH_API, 
    HOSO_NGHIENCUUSINH_API,
    DECUONGDAOTAO_API,
    CANBODAOTAO_API,
    LYLICHKHOAHOC_API, 
    MINHCHUNGKHOAHOC_API, 
    DECUONGNGHIENCUU_API, 
    VANBANGTUYENSINH_API, 
    VANBANGCHUNGCHINGOAINGU_API,
    VANBANGDAIHOC_API,
    NGANH_API,
    CHUYENNGANH_API,
    TRINHDO_API,
    DONVIDAOTAO_API,
    QUOCGIA_API,
    HINHTHUCDAOTAO_API,
    XEPLOAIDAOTAO_API,
    KETQUATUYENSINH_API,
    BaseGatewayImage,
    ACCOUNT_API,
    LOPDAOTAOLIENTUC_API,
    LOPDAOTAOTHUCHANH_API,
    DOITUONG_API,
    LICHSU_THAYDOI_HOSO_API
} from '@app/utils/apiUrl';
import {
    objectAccountGender,
    objectObjectAccount,
    objectDoiTuong,
    objectLoaiVanBang,
    objectCapQuanLy,
    objectLoaiCanBoHuongDan,
    doiTuongValue,
    loaiVanBangValue,
    capQuanLyValue,
    loaiCanBoHuongDanValue,
    gioiTinh as gioiTinhValue,
    objectTrinhDoDaoTaoTSTS,
    trinhDoDaoTaoTSTSValue,
    objectKetQuaTuyenSinh,
    objectThoiHanDaoTao,
    ketQuaTuyenSinhValue,
    thoiHanDaoTaoValue,
    trangThaiGuiKetQuaValue,
    objectTrangThaiHoSoDuTuyen,
    trangThaiHoSoDuTuyenValue,
    objectLoaiTuyenSinh,
    loaiTuyenSinhValue
} from '@app/utils/define';
import { useEffect } from 'react';
import LichSuThayDoiHoSoNCSTab from './LichSuThayDoiHoSoNCSTab';

const ThongTinNghienCuuSinhModal = ({ show, handleClose, hoSoId }) => {

    // APIs Data
    const { data: hoSoNCS, isLoading: load1 } = useQuery(['hoSoNCSDetail', hoSoId], () => Get(HOSO_NGHIENCUUSINH_API.GET_ITEM, hoSoId), { enabled: !!hoSoId });
    
    const hstsId = hoSoNCS?.hoSoTuyenSinhId || hoSoNCS?.HoSoTuyenSinhId;
    const { data: hoSo, isLoading: loadHsTs } = useQuery(['hoSoTuyenSinhDetail', hstsId], () => Get(HOSO_TUYENSINH_API.GET_ITEM, hstsId), { enabled: !!hstsId });

    const { data: lyLichRes, isLoading: load2 } = useQuery(['lyLich', hstsId], () => Get(LYLICHKHOAHOC_API.GET_BY_HOSO_ID, null, { hoSoTuyenSinhId: hstsId }), { enabled: !!hstsId });
    const { data: minhChungRes, isLoading: load3 } = useQuery(['minhChung', hstsId], () => Get(MINHCHUNGKHOAHOC_API.GET_BY_HOSO_ID, null, { hoSoTuyenSinhId: hstsId }), { enabled: !!hstsId });
    const { data: deCuongRes, isLoading: load4 } = useQuery(['deCuongTS', hstsId], () => Get(DECUONGNGHIENCUU_API.GET_BY_HOSO_ID, null, { hoSoTuyenSinhId: hstsId }), { enabled: !!hstsId });
    const { data: vanBangRes, isLoading: load5 } = useQuery(['vanBang', hstsId], () => Get(VANBANGTUYENSINH_API.GET_BY_HOSO_ID, hstsId), { enabled: !!hstsId });
    const { data: vbNgoaiNguRes, isLoading: load6 } = useQuery(['vbNgoaiNgu', hstsId], () => Get(VANBANGCHUNGCHINGOAINGU_API.GET_BY_HOSO_ID, hstsId), { enabled: !!hstsId });
    const { data: vanBangDaiHocRes, isLoading: loadVanBangDaiHoc } = useQuery(['vanBangDaiHoc', hstsId], () => Get(VANBANGDAIHOC_API.GET_BY_HOSO_ID, hstsId), { enabled: !!hstsId });
    const { data: ketQuaRes, isLoading: loadKetQua } = useQuery(['ketQuaTuyenSinh', hstsId], () => Get(KETQUATUYENSINH_API.GET_PAGING, null, { hoSoTuyenSinhId: hstsId, pageSize: 1 }), { enabled: !!hstsId });
    const { data: doiTuongRes } = useQuery(['doiTuongDataChucDanh'], () => Get(DOITUONG_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000 }), { enabled: show });
    const { data: lichSuRes } = useQuery(['lichSuThayDoi', hoSoId], () => Get(`${LICHSU_THAYDOI_HOSO_API.GET_BY_HOSO_ID}/${hoSoId}`), { enabled: !!hoSoId });
    const itemsLichSu = lichSuRes?.data?.$values || lichSuRes?.data || lichSuRes || [];
    const hasLichSu = Array.isArray(itemsLichSu) && itemsLichSu.length > 0;

    const loaiTuyenSinhRaw = hoSo?.loaiTuyenSinh ?? hoSo?.LoaiTuyenSinh;
    let actualLoaiTuyenSinh = loaiTuyenSinhRaw;
    if (typeof loaiTuyenSinhRaw === 'string') {
        actualLoaiTuyenSinh = loaiTuyenSinhValue[loaiTuyenSinhRaw] ?? loaiTuyenSinhValue[loaiTuyenSinhRaw.charAt(0).toLowerCase() + loaiTuyenSinhRaw.slice(1)];
    }

    const { data: khoahocData } = useQuery(['khoahocDetail', hoSo?.dotTuyenSinhId, actualLoaiTuyenSinh], () => {
        if (actualLoaiTuyenSinh === 1) return Get(LOPDAOTAOLIENTUC_API.GET_ITEM, hoSo?.dotTuyenSinhId);
        if (actualLoaiTuyenSinh === 2) return Get(LOPDAOTAOTHUCHANH_API.GET_ITEM, hoSo?.dotTuyenSinhId);
        return null;
    }, { enabled: !!hoSo?.dotTuyenSinhId && (actualLoaiTuyenSinh === 1 || actualLoaiTuyenSinh === 2) });

    // Dictionaries
    const { data: nganhRes } = useQuery(['nganhData'], () => Get(NGANH_API.GET_PAGING_NOT_MENU + '?pageSize=1000'), { enabled: show });
    const nganhOptions = (nganhRes?.data?.$values || nganhRes?.data || []).map(item => ({ value: item.id, label: item.tenNganh, maNganh: item.maNganh }));

    const { data: chuyenNganhRes } = useQuery(['chuyenNganhData'], () => Get(CHUYENNGANH_API.GET_PAGING_NOT_MENU + '?pageSize=1000'), { enabled: show });
    const chuyenNganhOptions = (chuyenNganhRes?.data?.$values || chuyenNganhRes?.data || []).map(item => ({ value: item.id, label: item.tenChuyenNganh, nganhId: item.nganhId }));

    const { data: trinhDoRes } = useQuery(['trinhDoData'], () => Get(TRINHDO_API.GET_ALL_PAGING + '?pageSize=1000'), { enabled: show });
    const trinhDoOptions = (trinhDoRes?.data?.$values || trinhDoRes?.data || []).map(item => ({ value: item.id, label: item.tenTrinhDo }));

    const { data: donViDaoTaoRes } = useQuery(['donViDaoTaoData'], () => Get(DONVIDAOTAO_API.GET_ALL_PAGING + '?pageSize=1000'), { enabled: show });
    const donViDaoTaoOptions = (donViDaoTaoRes?.data?.$values || donViDaoTaoRes?.data || []).map(item => ({ value: item.id, label: item.tenDonViDaoTao }));

    const { data: quocGiaRes } = useQuery(['quocGiaData'], () => Get(QUOCGIA_API.GET_ALL_PAGING + '?pageSize=1000'), { enabled: show });
    const quocGiaOptions = (quocGiaRes?.data?.$values || quocGiaRes?.data || []).map(item => ({ value: item.id, label: item.tenQuocGia }));

    const { data: hinhThucDaoTaoRes } = useQuery(['hinhThucDaoTaoData'], () => Get(HINHTHUCDAOTAO_API.GET_ALL_PAGING + '?pageSize=1000'), { enabled: show });
    const hinhThucDaoTaoOptions = (hinhThucDaoTaoRes?.data?.$values || hinhThucDaoTaoRes?.data || []).map(item => ({ value: item.id, label: item.tenHinhThuc }));

    const { data: xepLoaiDaoTaoRes } = useQuery(['xepLoaiDaoTaoData'], () => Get(XEPLOAIDAOTAO_API.GET_ALL_PAGING + '?pageSize=1000'), { enabled: show });
    const xepLoaiDaoTaoOptions = (xepLoaiDaoTaoRes?.data?.$values || xepLoaiDaoTaoRes?.data || []).map(item => ({ value: item.id, label: item.tenXepLoai }));

    const isLoading = load1 || load2 || load3 || load4 || load5 || load6 || loadVanBangDaiHoc;

    const dataHoSo = hoSo || {};
    const dataLyLich = lyLichRes?.data || {};
    const dataMinhChung = minhChungRes?.data || {};
    const dataDeCuong = deCuongRes?.data || {};

    let dataKetQuaTuyenSinh = null;
    if (ketQuaRes?.data) {
        if (Array.isArray(ketQuaRes.data)) dataKetQuaTuyenSinh = ketQuaRes.data[0];
        else if (ketQuaRes.data.data && Array.isArray(ketQuaRes.data.data)) dataKetQuaTuyenSinh = ketQuaRes.data.data[0];
        else if (ketQuaRes.data.Data && Array.isArray(ketQuaRes.data.Data)) dataKetQuaTuyenSinh = ketQuaRes.data.Data[0];
        else if (ketQuaRes.data.$values && Array.isArray(ketQuaRes.data.$values)) dataKetQuaTuyenSinh = ketQuaRes.data.$values[0];
        else if (ketQuaRes.data.data && ketQuaRes.data.data.$values) dataKetQuaTuyenSinh = ketQuaRes.data.data.$values[0];
        else dataKetQuaTuyenSinh = ketQuaRes.data;
    }

    const getEnumValue = (value, valueMap) => {
        if (value === null || value === undefined || value === '') return value;
        if (typeof value === 'number') return value;
        if (typeof value === 'string' && valueMap) {
            if (valueMap[value] !== undefined) return valueMap[value];
            const camelCase = value.charAt(0).toLowerCase() + value.slice(1);
            if (valueMap[camelCase] !== undefined) return valueMap[camelCase];
            const matchKey = Object.keys(valueMap).find(k => k.toLowerCase() === value.toLowerCase());
            if (matchKey) return valueMap[matchKey];
            if (!isNaN(value)) return parseInt(value);
        }
        return value;
    };

    const rawTrangThaiGui = dataKetQuaTuyenSinh ? (dataKetQuaTuyenSinh.trangThaiGuiKetQua !== undefined ? dataKetQuaTuyenSinh.trangThaiGuiKetQua : dataKetQuaTuyenSinh.TrangThaiGuiKetQua) : null;
    const actualTrangThaiGui = getEnumValue(rawTrangThaiGui, trangThaiGuiKetQuaValue);
    const isDaGuiKetQua = (val) => {
        return val === trangThaiGuiKetQuaValue.daGui;
    };
    
    // Arrays
    const baiBaoKhoaHocs = dataLyLich.baiBaoKhoaHocs?.$values || dataLyLich.baiBaoKhoaHocs || [];
    const deTaiNCKHs = dataMinhChung.deTaiNCKHs?.$values || dataMinhChung.deTaiNCKHs || [];

    const { data: deCuongDaoTaoRes } = useQuery(
        ['deCuongDaoTao', hoSoId],
        () => Get(DECUONGDAOTAO_API.GET_PAGING, null, { HoSoNghienCuuSinhId: hoSoId, pageSize: 1 }),
        { enabled: !!hoSoId }
    );
    const dataDeCuongDaoTao = deCuongDaoTaoRes?.data?.$values?.[0] || deCuongDaoTaoRes?.data?.data?.[0] || deCuongDaoTaoRes?.data?.[0] || null;

    const { data: canBoDaoTaoRes } = useQuery(
        ['canBoDaoTaoList', dataDeCuongDaoTao?.id],
        () => Get(CANBODAOTAO_API.GET_PAGING, null, { DeCuongDaoTaoId: dataDeCuongDaoTao.id, pageSize: 100 }),
        { enabled: !!dataDeCuongDaoTao?.id }
    );
    const canBoDaoTaos = canBoDaoTaoRes?.data?.$values || canBoDaoTaoRes?.data?.data || canBoDaoTaoRes?.data || [];

    const finalDataDeCuong = dataDeCuongDaoTao ? {
        tenDeCuong: dataDeCuongDaoTao.tenDeTai,
        fileMinhChung: dataDeCuongDaoTao.fileMinhChung
    } : dataDeCuong;

    const rawCanBoHuongDans = dataDeCuongDaoTao ? canBoDaoTaos.map(cb => ({
        hoTen: cb.hoTen,
        loaiCanBoHuongDan: cb.loaiCanBoHuongDan,
        donViCongTac: cb.donViCongTac,
        fileLyLichKhoaHoc: cb.fileLyLichKhoaHoc,
        fileMinhChungCanBo: cb.fileMinhChung
    })) : (dataDeCuong.canBoHuongDans?.$values || dataDeCuong.canBoHuongDans || []);

    const canBoHuongDans = rawCanBoHuongDans;

    const vanBangTuyenSinhs = vanBangRes?.data?.$values || vanBangRes?.data || [];
    const vanBangNgoaiNgus = vbNgoaiNguRes?.data?.$values || vbNgoaiNguRes?.data || [];
    const vanBangDaiHocs = vanBangDaiHocRes?.data?.$values || vanBangDaiHocRes?.data || [];


    const { data: itemAccountAuthInfoRes } = useQuery(
        ['accountAuthInfoLocal', dataHoSo?.accountId], 
        () => Get(ACCOUNT_API.GET_ACCOUNT_BYID_FROM_APP_DUNGCHUNG, dataHoSo?.accountId), 
        { enabled: !!dataHoSo?.accountId && show }
    );
    const { data: itemAccountInfoRes } = useQuery(
        ['accountInfoLocal', dataHoSo?.accountId], 
        () => Get(ACCOUNT_API.GET_ACCOUNT_INFO_BYID_FROM_APP_DUNGCHUNG, dataHoSo?.accountId), 
        { enabled: !!dataHoSo?.accountId && show }
    );

    const itemAccountAuthInfo = itemAccountAuthInfoRes?.data || itemAccountAuthInfoRes || {};
    const itemAccountInfo = itemAccountInfoRes?.data || itemAccountInfoRes || {};

    useEffect(() => {
        // Removed Redux dispatch that overwritten current user state
    }, [show, dataHoSo?.accountId]);

    const donViName = itemAccountInfo?.donVis?.length > 0 
        ? itemAccountInfo.donVis.map(d => d.tenDonVi).join(', ') 
        : (itemAccountInfo?.donViNgoaiVien || dataHoSo?.donViNgoaiVien || '');
        
    const thuongTruTinhThanh = dataHoSo.thuongTruTinhThanh || dataHoSo.ThuongTruTinhThanh || itemAccountAuthInfo?.hkttAdressProvinceCity || '...';
    const thuongTruXaPhuong = dataHoSo.thuongTruXaPhuong || dataHoSo.ThuongTruXaPhuong || itemAccountAuthInfo?.hkttAdressWardCommune || '...';
    const thuongTruDiaChi = dataHoSo.thuongTruDiaChi || dataHoSo.ThuongTruDiaChi || itemAccountAuthInfo?.address || '...';
    const soCCCD = dataHoSo.soCCCD || dataHoSo.SoCCCD || itemAccountAuthInfo?.identityCardNumber || '...';
    const ngayCapCCCD = dataHoSo.ngayCapCCCD || dataHoSo.NgayCapCCCD || itemAccountAuthInfo?.issuanceDateOfIdentityCard;
    const ngayCapCCCDStr = ngayCapCCCD ? moment(ngayCapCCCD).format('DD/MM/YYYY') : '...';
    const noiCapCCCD = dataHoSo.noiCapCCCD || dataHoSo.NoiCapCCCD || itemAccountAuthInfo?.issuancePlaceOfIdentityCard || '...';

    const getLabelFromEnum = (value, objectEnum, valueMap = null) => {
        if (value === null || value === undefined || value === '') return '';
        let actualValue = value;
        if (typeof value === 'string' && valueMap) {
            // Exact match
            if (valueMap[value] !== undefined) actualValue = valueMap[value];
            else {
                // CamelCase match
                const camelCase = value.charAt(0).toLowerCase() + value.slice(1);
                if (valueMap[camelCase] !== undefined) actualValue = valueMap[camelCase];
                else {
                    // Case-insensitive
                    const matchKey = Object.keys(valueMap).find(k => k.toLowerCase() === value.toLowerCase());
                    if (matchKey) actualValue = valueMap[matchKey];
                }
            }
        }
        const found = objectEnum.find((item) => item.value === actualValue || item.value == value);
        return found ? found.label : (valueMap ? '' : value);
    };

    // Formatters
    const customLoaiCanBoMap = { ...loaiCanBoHuongDanValue, canBoHuongDanChinh: 0, canBoHuongDanPhu: 1, dongHuongDan: 2 };
    const accountGenderName = objectAccountGender.find(x => x.value === itemAccountAuthInfo?.accountGender)?.label;
    const getDoiTuong = (val) => {
        const isQuan = val === 1 || val === '1' || val === doiTuongValue.quan || val === 'quanNhan' || String(val).toLowerCase() === 'quan';
        return objectObjectAccount.find(x => x.value === (isQuan ? 'quanNhan' : 'khac'))?.label || 'Khác';
    };
    const getLoaiVanBang = (val) => getLabelFromEnum(val, objectLoaiVanBang, loaiVanBangValue);
    const getCapQuanLy = (val) => getLabelFromEnum(val, objectCapQuanLy, capQuanLyValue);
    const getLoaiCanBo = (val) => getLabelFromEnum(val, objectLoaiCanBoHuongDan, customLoaiCanBoMap);
    const getNganh = (val) => nganhOptions.find(x => x.value === val)?.label || '';
    const getMaNganh = (val) => nganhOptions.find(x => x.value === val)?.maNganh || '';
    const getChuyenNganh = (val) => chuyenNganhOptions.find(x => x.value === val)?.label || '';
    const getTrinhDo = (val) => getLabelFromEnum(val, objectTrinhDoDaoTaoTSTS, trinhDoDaoTaoTSTSValue);
    const getDonViDaoTao = (val) => donViDaoTaoOptions.find(x => x.value === val)?.label || '';
    const getQuocGia = (val) => quocGiaOptions.find(x => x.value === val)?.label || '';
    const getHinhThuc = (val) => hinhThucDaoTaoOptions.find(x => x.value === val)?.label || '';
    const getXepLoai = (val) => xepLoaiDaoTaoOptions.find(x => x.value === val)?.label || '';
    const getKetQuaTuyenSinh = (val) => {
        let actualValue = val;
        if (typeof val === 'string' && ketQuaTuyenSinhValue) {
            if (ketQuaTuyenSinhValue[val] !== undefined) actualValue = ketQuaTuyenSinhValue[val];
            else {
                const matchKey = Object.keys(ketQuaTuyenSinhValue).find(k => k.toLowerCase() === val.toLowerCase());
                if (matchKey) actualValue = ketQuaTuyenSinhValue[matchKey];
            }
        }
        const item = objectKetQuaTuyenSinh.find(x => x.value === actualValue || x.value == val);
        if (!item) return <span className="text-muted font-italic">Chưa cập nhật</span>;
        return <span className={`text-${item.color} font-weight-bold`}>{item.label}</span>;
    };
    const getThoiHanDaoTao = (val) => getLabelFromEnum(val, objectThoiHanDaoTao, thoiHanDaoTaoValue);
    const getTrinhDoId = (val) => trinhDoOptions.find(x => x.value === val)?.label || '';

    const loaiTuyenSinhLabel = getLabelFromEnum(dataHoSo.loaiTuyenSinh ?? dataHoSo.LoaiTuyenSinh ?? loaiTuyenSinhValue.tuyenSinhTienSi, objectLoaiTuyenSinh, loaiTuyenSinhValue);
    const isTuyenSinhTienSi = loaiTuyenSinhLabel === 'Tuyển sinh Tiến sĩ';
    const loaiTuyenSinh = isTuyenSinhTienSi ? 0 : 1; // mapping back for conditional rendering later

    let noteColor = '#b45309';
    let noteBgColor = '#fffbeb';
    let noteBorderColor = '#f59e0b';
    let iconClass = 'fa-exclamation-circle';
    
    const hsStatusLabel = getLabelFromEnum(dataHoSo.trangThaiHoSoDuTuyen ?? dataHoSo.TrangThaiHoSoDuTuyen, objectTrangThaiHoSoDuTuyen, trangThaiHoSoDuTuyenValue);
    
    if (hsStatusLabel === 'Duyệt') {
        noteColor = '#065f46';
        noteBgColor = '#ecfdf5';
        noteBorderColor = '#10b981';
        iconClass = 'fa-check-circle';
    } else if (hsStatusLabel === 'Từ chối') {
        noteColor = '#991b1b';
        noteBgColor = '#fef2f2';
        noteBorderColor = '#ef4444';
        iconClass = 'fa-times-circle';
    }

    const FieldDisplay = ({ label, value, isRequired, highlight }) => (
        <div className="mb-3">
            <div className="text-secondary small font-weight-bold mb-1">{label} {isRequired && <span className="text-danger">*</span>}</div>
            <div className={highlight ? "text-primary" : "text-dark"} style={{ fontSize: '15px', fontWeight: highlight ? '600' : '500', wordBreak: 'break-word', minHeight: '24px' }}>
                {value !== null && value !== undefined && value !== '' ? value : <span className="text-muted font-italic" style={{ fontWeight: 'normal' }}>Chưa cập nhật</span>}
            </div>
        </div>
    );

    const FieldDisplayFile = ({ label, value, isRequired }) => {
        const getSafeUrl = (path) => {
            if (!path) return null;
            if (path.startsWith('http')) return path;
            const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
            const safePath = path.startsWith('/') ? path : `/${path}`;
            return `${baseUrl}${safePath}`;
        };

        let files = [];
        if (value) {
            try {
                const parsed = JSON.parse(value);
                if (Array.isArray(parsed)) {
                    files = parsed;
                } else {
                    files = [value];
                }
            } catch (e) {
                files = [value];
            }
        }

        return (
            <div className="mb-3">
                {label && <div className="text-secondary small font-weight-bold mb-1">{label} {isRequired && <span className="text-danger">*</span>}</div>}
                <div className="d-flex flex-wrap">
                    {files.length > 0 ? (
                        files.map((file, idx) => {
                            const path = file.filePath || file;
                            let name = file.name || (typeof path === 'string' ? path.split('/').pop() : 'File');
                            name = name.replace(/_\d{14}(?=\.\w+$|$)/, '');
                            return (
                                <a key={idx} href={getSafeUrl(path)} target="_blank" rel="noreferrer" className={`btn btn-outline-primary text-left ${label ? '' : 'btn-sm'} mb-1 mr-2`} style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block', borderRadius: '4px' }} title={name}>
                                    <i className="fas fa-paperclip mr-1"></i> {name}
                                </a>
                            );
                        })
                    ) : (
                        <div className={label ? "d-flex align-items-center" : ""} style={label ? { height: '24px' } : {}}>
                            <span className="text-muted font-italic small">Không có file đính kèm</span>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <Modal show={show} onHide={handleClose} size="xl" backdrop="static" style={{ zIndex: 9999 }}>
            <Modal.Header closeButton className="bg-primary text-white" style={{ borderBottom: 'none' }}>
                <Modal.Title className="font-weight-bold" style={{ fontSize: '1.25rem' }}>
                    <i className="fas fa-file-alt mr-2"></i> Chi tiết hồ sơ Nghiên cứu sinh
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0 custom-modal-body" style={{ maxHeight: 'calc(100vh - 120px)', overflowY: 'auto', backgroundColor: '#f4f6f9' }}>


                {isLoading ? (
                    <div className="text-center py-5">
                        <Spinner animation="border" variant="primary" />
                        <p className="mt-2 text-muted">Đang tải dữ liệu...</p>
                    </div>
                ) : (
                    <>
                        {!!(dataHoSo.ghiChuChinhSua?.trim() || dataHoSo.GhiChuChinhSua?.trim()) && (
                            <div className="alert mb-0 mx-3 mt-3 shadow-sm" style={{ backgroundColor: noteBgColor, borderLeft: `5px solid ${noteBorderColor}`, color: noteColor }}>
                                <h6 className="alert-heading font-weight-bold mb-2">
                                    <i className={`fas ${iconClass} mr-2`} style={{ color: noteBorderColor }}></i> Phản hồi từ cán bộ duyệt hồ sơ:
                                </h6>
                                <p className="mb-0 ml-4" style={{ whiteSpace: 'pre-wrap', fontSize: '0.95rem' }}>
                                    {dataHoSo.ghiChuChinhSua || dataHoSo.GhiChuChinhSua}
                                </p>
                            </div>
                        )}
                        <Tabs defaultActiveKey="thong-tin-ca-nhan" className="custom-tabs px-3 pt-3">
                        <Tab eventKey="thong-tin-ca-nhan" title={<span><i className="fas fa-user mr-1"></i> Thông tin thí sinh</span>}>
                            <div className="bg-white p-4 border rounded mx-3 mb-4 mt-3" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                                <Row>
                                    <Col md={12}><FieldDisplay label="Số hồ sơ" value={dataHoSo.soHoSo || dataHoSo.SoHoSo || 'Chưa cấp'} /></Col>
                                    <Col md={4}><FieldDisplay label="Họ tên" value={dataHoSo.hoTen} /></Col>
                                    <Col md={4}><FieldDisplay label="Ngày sinh" value={dataHoSo.ngaySinh ? moment(dataHoSo.ngaySinh).format('DD/MM/YYYY') : ''} /></Col>
                                    <Col md={4}><FieldDisplay label="Giới tính" value={accountGenderName} /></Col>
                                    <Col md={4}><FieldDisplay label="Số CCCD" value={soCCCD} /></Col>
                                    <Col md={4}><FieldDisplay label="Ngày cấp CCCD" value={ngayCapCCCDStr} /></Col>
                                    <Col md={4}><FieldDisplay label="Nơi cấp CCCD" value={noiCapCCCD} /></Col>
                                    <Col md={4}><FieldDisplay label="Đối tượng" value={getDoiTuong((dataHoSo.doiTuong !== undefined && dataHoSo.doiTuong !== 0) ? dataHoSo.doiTuong : ((dataHoSo.DoiTuong !== undefined && dataHoSo.DoiTuong !== 0) ? dataHoSo.DoiTuong : itemAccountAuthInfo?.objectAccount))} /></Col>
                                    <Col md={4}><FieldDisplay label="Email" value={dataHoSo.email} /></Col>
                                    <Col md={4}><FieldDisplay label="Số điện thoại" value={dataHoSo.soDienThoai} /></Col>
                                    <Col md={12}><FieldDisplay label="Đơn vị công tác" value={donViName} /></Col>
                                    <Col md={4}><FieldDisplay label="Thường trú (Tỉnh / Thành phố)" value={thuongTruTinhThanh} /></Col>
                                    <Col md={8}><FieldDisplay label="Thường trú (Xã / Phường)" value={thuongTruXaPhuong} /></Col>
                                    <Col md={12}><FieldDisplay label="Thường trú (Địa chỉ chi tiết)" value={thuongTruDiaChi} /></Col>
                                    <Col md={12}><FieldDisplay label="Nơi sinh (Tỉnh / Thành phố)" value={dataHoSo.noiSinh} /></Col>
                                    <Col md={4}><FieldDisplay label="Họ tên người liên hệ" value={dataHoSo.hoTenNguoiLienHe} /></Col>
                                    <Col md={4}><FieldDisplay label="Quan hệ" value={dataHoSo.quanHeNguoiLienHe || dataHoSo.QuanHeNguoiLienHe || ''} /></Col>
                                    <Col md={4}><FieldDisplay label="SĐT người liên hệ" value={dataHoSo.sdtNguoiLienHe} /></Col>
                                    <Col md={12}><FieldDisplay label="Thuộc đối tượng miễn giảm" value={dataHoSo.isDoiTuongMienGiam === true || dataHoSo.IsDoiTuongMienGiam === true ? 'Có' : (dataHoSo.isDoiTuongMienGiam === false || dataHoSo.IsDoiTuongMienGiam === false ? 'Không' : '')} /></Col>
                                </Row>
                            </div>
                        </Tab>

                        <Tab eventKey="thong-tin-du-tuyen" title={<span><i className="fas fa-clipboard-list mr-1"></i> Thông tin đăng ký dự tuyển</span>}>
                            <div className="bg-white p-4 border rounded mx-3 mb-4 mt-3" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                                {loaiTuyenSinh === 0 ? (
                                    <Row>
                                        <Col md={dataHoSo.chuyenNganhId ? 6 : 12}><FieldDisplay label="Ngành đăng ký" value={getNganh(dataHoSo.nganhId)} /></Col>
                                        {dataHoSo.chuyenNganhId && (
                                            <Col md={6}><FieldDisplay label="Chuyên ngành đăng ký" value={getChuyenNganh(dataHoSo.chuyenNganhId)} /></Col>
                                        )}
                                    </Row>
                                ) : (
                                    <Row>
                                        <Col md={12}><FieldDisplay label="Tên khóa học" value={khoahocData?.tenKhoaHoc || khoahocData?.TenKhoaHoc || khoahocData?.data?.tenKhoaHoc || khoahocData?.data?.TenKhoaHoc || dataHoSo.tenDotTuyenSinh || dataHoSo.TenDotTuyenSinh || ''} /></Col>
                                        {actualLoaiTuyenSinh === 2 && (
                                            <Col md={12}><FieldDisplay label="Chức danh đăng ký đào tạo" value={(doiTuongRes?.data?.$values || doiTuongRes?.data || []).find(d => String(d.id || d.Id).toLowerCase() === String(dataHoSo.chucDanhId || dataHoSo.ChucDanhId).toLowerCase())?.tenDoiTuong || ''} /></Col>
                                        )}
                                    </Row>
                                )}
                            </div>
                        </Tab>

                        <Tab eventKey="van-bang" title={<span><i className="fas fa-graduation-cap mr-1"></i> Quá trình đào tạo</span>}>
                            <div className="bg-white p-4 border rounded mx-3 mb-4 mt-3" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                            {loaiTuyenSinh === 0 ? (
                                <>
                                    <h5 className="font-weight-bold mt-2 mb-3 pb-2 border-bottom" style={{ color: "#1e7e34" }}><i className="fas fa-user-md mr-2"></i>Đào tạo đại học (Bác sĩ)</h5>
                                    {vanBangDaiHocs.length > 0 ? (
                                        vanBangDaiHocs.map((vb, idx) => (
                                            <Card key={idx} className="mb-3 shadow-sm border-info">
                                                <Card.Body>
                                                    <Row>
                                                        <Col md={4}><FieldDisplay label="Loại văn bằng" value={getLoaiVanBang(vb.loaiVanBang)} /></Col>
                                                        <Col md={8}><FieldDisplay label="Trường đào tạo" value={
                                                            (getLoaiVanBang(vb.loaiVanBang) === 'Ngoài nước') ? vb.tenTruongNuocNgoai : getDonViDaoTao(vb.donViDaoTaoId)
                                                        } /></Col>
                                                        <Col md={4}><FieldDisplay label="Quốc gia" value={getQuocGia(vb.quocGiaId)} /></Col>
                                                        <Col md={4}><FieldDisplay label="Xếp loại" value={getXepLoai(vb.xepLoaiDaoTaoId)} /></Col>
                                                        <Col md={4}><FieldDisplay label="Năm tốt nghiệp" value={vb.namTotNghiep} /></Col>
                                                        <Col md={12}><FieldDisplay label="Ngành" value={vb.nganhDaoTao} /></Col>
                                                        <Col md={12}><FieldDisplayFile label="File minh chứng văn bằng" value={vb.fileMinhChung} /></Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        ))
                                    ) : <div className="alert alert-secondary">Không có dữ liệu đào tạo đại học (Bác sĩ)</div>}

                                    <h5 className="font-weight-bold mt-4 mb-3 pb-2 border-bottom" style={{ color: "#1e7e34" }}><i className="fas fa-user-graduate mr-2"></i>Đào tạo sau đại học (Thạc sĩ, BSCKI, BSCKII, Bác sĩ nội trú)</h5>
                                    {vanBangTuyenSinhs.length > 0 ? (
                                        vanBangTuyenSinhs.map((vb, idx) => (
                                            <Card key={idx} className="mb-3 shadow-sm border-info">
                                                <Card.Body>
                                                    <Row>
                                                        <Col md={4}><FieldDisplay label="Loại văn bằng" value={getLoaiVanBang(vb.loaiVanBang)} /></Col>
                                                        <Col md={8}><FieldDisplay label="Trường đào tạo" value={
                                                            (getLoaiVanBang(vb.loaiVanBang) === 'Ngoài nước') ? vb.tenTruongNuocNgoai : getDonViDaoTao(vb.donViDaoTaoId)
                                                        } /></Col>
                                                        <Col md={4}><FieldDisplay label="Trình độ" value={getTrinhDo(vb.trinhDo)} /></Col>
                                                        <Col md={4}><FieldDisplay label="Quốc gia" value={getQuocGia(vb.quocGiaId)} /></Col>
                                                        <Col md={4}><FieldDisplay label="Hình thức đào tạo" value={getHinhThuc(vb.hinhThucDaoTaoId)} /></Col>
                                                        <Col md={4}><FieldDisplay label="Xếp loại" value={getXepLoai(vb.xepLoaiDaoTaoId)} /></Col>
                                                        <Col md={vb.chuyenNganhDaoTao ? 4 : 8}><FieldDisplay label="Ngành" value={vb.nganhDaoTao} /></Col>
                                                        {vb.chuyenNganhDaoTao && (
                                                            <Col md={4}><FieldDisplay label="Chuyên ngành" value={vb.chuyenNganhDaoTao} /></Col>
                                                        )}
                                                        <Col md={4}><FieldDisplay label="Điểm luận văn tốt nghiệp" value={vb.diemLuanVanTN} /></Col>
                                                        <Col md={4}><FieldDisplay label="Điểm trung bình toàn khóa" value={vb.diemTBToanKhoa} /></Col>
                                                        <Col md={4}><FieldDisplay label="Năm tốt nghiệp" value={vb.namTotNghiep} /></Col>
                                                        <Col md={12}><FieldDisplayFile label="File minh chứng văn bằng" value={vb.fileMinhChung} /></Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        ))
                                    ) : <div className="alert alert-secondary">Không có dữ liệu đào tạo sau đại học</div>}

                                    <h5 className="font-weight-bold mt-4 mb-3 pb-2 border-bottom" style={{ color: "#1e7e34" }}><i className="fas fa-certificate mr-2"></i>Văn bằng/Chứng chỉ ngoại ngữ</h5>
                                    {vanBangNgoaiNgus.length > 0 ? (
                                        vanBangNgoaiNgus.map((vb, idx) => (
                                            <Card key={idx} className="mb-3 shadow-sm border-warning">
                                                <Card.Body>
                                                    <Row>
                                                        <Col md={4}><FieldDisplay label="Tên văn bằng/chứng chỉ" value={vb.tenVanBangChungChi} /></Col>
                                                        <Col md={4}><FieldDisplay label="Nơi học" value={vb.noiHoc} /></Col>
                                                        <Col md={4}><FieldDisplay label="Ngày cấp" value={vb.ngayCap ? new Date(vb.ngayCap).toLocaleDateString('vi-VN') : ''} /></Col>
                                                        <Col md={8}><FieldDisplay label="Ghi chú" value={vb.ghiChu} /></Col>
                                                        <Col md={12}><FieldDisplayFile label="File minh chứng ngoại ngữ" value={vb.fileMinhChung} /></Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        ))
                                    ) : <div className="alert alert-secondary">Không có dữ liệu văn bằng/chứng chỉ ngoại ngữ</div>}
                                </>
                            ) : (
                                <>
                                    <h5 className="font-weight-bold mt-2 mb-3 pb-2 border-bottom" style={{ color: "#1e7e34" }}><i className="fas fa-user-graduate mr-2"></i>Thông tin văn bằng</h5>
                                    {vanBangDaiHocs.length > 0 ? (
                                        vanBangDaiHocs.map((vb, idx) => (
                                            <Card key={idx} className="mb-3 shadow-sm border-info">
                                                <Card.Body>
                                                    <Row>
                                                        <Col md={4}><FieldDisplay label="Loại văn bằng" value={getLoaiVanBang(vb.loaiVanBang ?? vb.LoaiVanBang)} /></Col>
                                                        <Col md={8}><FieldDisplay label="Trường đào tạo" value={
                                                            (getLoaiVanBang(vb.loaiVanBang ?? vb.LoaiVanBang) === 'Ngoài nước') ? (vb.tenTruongNuocNgoai ?? vb.TenTruongNuocNgoai) : getDonViDaoTao(vb.donViDaoTaoId ?? vb.DonViDaoTaoId)
                                                        } /></Col>
                                                        <Col md={4}><FieldDisplay label="Quốc gia" value={getQuocGia(vb.quocGiaId ?? vb.QuocGiaId)} /></Col>
                                                        <Col md={4}><FieldDisplay label="Hệ đào tạo" value={getTrinhDoId(vb.trinhDoId ?? vb.TrinhDoId)} /></Col>
                                                        <Col md={4}><FieldDisplay label="Năm tốt nghiệp" value={vb.namTotNghiep ?? vb.NamTotNghiep} /></Col>
                                                        <Col md={12}><FieldDisplayFile label="File minh chứng" value={vb.fileMinhChung ?? vb.FileMinhChung} /></Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        ))
                                    ) : <div className="alert alert-secondary">Không có dữ liệu văn bằng</div>}

                                    <h5 className="font-weight-bold mt-4 mb-3 pb-2 border-bottom" style={{ color: "#1e7e34" }}><i className="fas fa-file-alt mr-2"></i>Các văn bằng khác liên quan đến khóa học</h5>
                                    <Row>
                                        <Col md={12}><FieldDisplayFile label="File văn bằng" value={dataHoSo.fileVanBangKhac ?? dataHoSo.FileVanBangKhac} /></Col>
                                    </Row>
                                </>
                            )}
                            </div>
                        </Tab>

                        {loaiTuyenSinh === 0 && (
                            <Tab eventKey="nghien-cuu" title={<span><i className="fas fa-book mr-1"></i> Nghiên cứu khoa học</span>}>
                                <div className="bg-white p-4 border rounded mx-3 mb-4 mt-3" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                                <div className="d-flex justify-content-start align-items-center mb-3 pb-2 border-bottom">
                                    <h5 className="font-weight-bold mb-0 mr-4" style={{ color: "#1e7e34" }}><i className="fas fa-newspaper mr-2"></i>Bài báo khoa học</h5>
                                    <h6 className="text-primary font-weight-bold mb-0">Số lượng: <strong className="text-danger">{dataHoSo.soLuongBaiBao || dataHoSo.SoLuongBaiBao || 0}</strong></h6>
                                </div>
                                {baiBaoKhoaHocs.length > 0 ? (
                                    <Table striped bordered hover size="sm">
                                        <thead className="bg-light">
                                            <tr>
                                                <th>Tên bài báo</th>
                                                <th>Tạp chí đăng</th>
                                                <th>Năm công bố</th>
                                                <th>Minh chứng</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {baiBaoKhoaHocs.map((bb, idx) => (
                                                <tr key={idx}>
                                                    <td>{bb.tenBaiBao}</td>
                                                    <td>{bb.tapChiDang}</td>
                                                    <td>{bb.namCongBo}</td>
                                                    <td><FieldDisplayFile value={bb.fileMinhChung} /></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                ) : <div className="alert alert-secondary">Không có dữ liệu bài báo khoa học</div>}
                                <div className="mt-2 mb-3">
                                    <FieldDisplayFile label="File lý lịch khoa học đính kèm" value={dataLyLich.fileLyLichKhoaHoc} />
                                </div>

                                <div className="d-flex justify-content-start align-items-center mt-4 mb-3 pb-2 border-bottom">
                                    <h5 className="font-weight-bold mb-0 mr-4" style={{ color: "#1e7e34" }}><i className="fas fa-microscope mr-2"></i>Đề tài nghiên cứu khoa học</h5>
                                    <h6 className="text-primary font-weight-bold mb-0">Số lượng: <strong className="text-danger">{dataHoSo.soLuongDeTaiKhoaHoc || dataHoSo.SoLuongDeTaiKhoaHoc || 0}</strong></h6>
                                </div>
                                {deTaiNCKHs.length > 0 ? (
                                    <Table striped bordered hover size="sm">
                                        <thead className="bg-light">
                                            <tr>
                                                <th>Tên đề tài</th>
                                                <th>Cấp quản lý</th>
                                                <th>Năm nghiệm thu</th>
                                                <th>Minh chứng</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {deTaiNCKHs.map((dt, idx) => (
                                                <tr key={idx}>
                                                    <td>{dt.tenDeTaiNCKH}</td>
                                                    <td>{getCapQuanLy(dt.capQuanLy)}</td>
                                                    <td>{dt.namNghiemThu}</td>
                                                    <td><FieldDisplayFile value={dt.fileMinhChung} /></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                ) : <div className="alert alert-secondary">Không có dữ liệu đề tài NCKH</div>}


                                </div>
                            </Tab>
                        )}

                        {loaiTuyenSinh === 0 && (
                            <Tab eventKey="de-cuong-du-tuyen" title={<span><i className="fas fa-file-signature mr-1"></i> Đề cương dự tuyển</span>}>
                                <div className="bg-white p-4 border rounded mx-3 mb-4 mt-3" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                                    <h5 className="font-weight-bold mb-4 border-bottom pb-2" style={{ color: "#1e7e34" }}>
                                        <i className="fas fa-file-signature mr-2"></i> Đề cương nghiên cứu & Cán bộ hướng dẫn
                                    </h5>
                                    <Row>
                                        <Col md={12}><FieldDisplay label="Tên đề cương" value={finalDataDeCuong.tenDeCuong || ''} /></Col>
                                    </Row>
                                    <div className="mt-2 mb-3">
                                        <FieldDisplayFile label="File đề cương nghiên cứu đính kèm" value={finalDataDeCuong.fileMinhChung} />
                                    </div>
                                    {canBoHuongDans.length > 0 ? (
                                        <Table striped bordered hover size="sm" responsive>
                                            <thead className="bg-white">
                                                <tr>
                                                    <th style={{ whiteSpace: 'nowrap' }}>Họ tên</th>
                                                    <th style={{ whiteSpace: 'nowrap' }}>Vai trò cán bộ</th>
                                                    <th style={{ whiteSpace: 'nowrap' }}>Đơn vị công tác</th>
                                                    <th style={{ width: '25%' }}>Giấy chấp thuận</th>
                                                    <th style={{ width: '25%' }}>Minh chứng</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {canBoHuongDans.map((cb, idx) => (
                                                    <tr key={idx}>
                                                        <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>{cb.hoTen}</td>
                                                        <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>{getLoaiCanBo(cb.loaiCanBoHuongDan)}</td>
                                                        <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>{cb.donViCongTac}</td>
                                                        <td className="align-middle"><FieldDisplayFile value={cb.fileLyLichKhoaHoc} /></td>
                                                        <td className="align-middle"><FieldDisplayFile value={cb.fileMinhChungCanBo} /></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    ) : <p className="text-muted small">Không có cán bộ hướng dẫn</p>}
                                </div>
                            </Tab>
                        )}

                        <Tab eventKey="ho-so-dinh-kem" title={<span><i className="fas fa-paperclip mr-1"></i> Hồ sơ đính kèm</span>}>
                            <div className="bg-white p-4 border rounded mx-3 mb-4 mt-3" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                                {loaiTuyenSinh === 0 ? (
                                    <Row>
                                        <Col md={6}><FieldDisplayFile label="1. Đơn đăng ký dự tuyển" value={dataHoSo.fileDonXinDuTuyen} /></Col>
                                        <Col md={6}><FieldDisplayFile label="2. Công văn/Quyết định cử đi dự tuyển của cơ quan chủ quản (không áp dụng với thí sinh quân đội, thí sinh tự do)" value={dataHoSo.fileCongVanCuDi} /></Col>
                                        <Col md={6}><FieldDisplayFile label="3. Sơ yếu lý lịch" value={dataHoSo.fileSoYeuLyLich} /></Col>
                                        <Col md={6}><FieldDisplayFile label="4. Giấy khám sức khỏe" value={dataHoSo.fileGiayKhamSucKhoe} /></Col>
                                        <Col md={6}><FieldDisplayFile label="5. Thư giới thiệu của giáo sư/phó giáo sư (chỉ áp dụng với thí sinh tự do)" value={dataHoSo.fileGiayChapThuan} /></Col>
                                        <Col md={6}><FieldDisplayFile label="6. Ảnh chân dung 3x4 cm chụp trong vòng 1 năm trở lại đây" value={dataHoSo.fileAnhChanDung} /></Col>
                                        <Col md={6}><FieldDisplayFile label="7. Minh chứng đóng lệ phí" value={dataHoSo.fileMinhChungLePhi} /></Col>
                                        {(dataHoSo.isDoiTuongMienGiam === true || dataHoSo.IsDoiTuongMienGiam === true) && (
                                            <Col md={6}><FieldDisplayFile label="8. Minh chứng miễn giảm" value={dataHoSo.fileMinhChungMienGiam || dataHoSo.FileMinhChungMienGiam} /></Col>
                                        )}
                                    </Row>
                                ) : (
                                    <Row>
                                        <Col md={6}><FieldDisplayFile label="1. Đơn đăng ký học" value={dataHoSo.fileDonXinDuTuyen} /></Col>
                                        <Col md={6}><FieldDisplayFile label="2. Bằng tốt nghiệp (công chứng)" value={dataHoSo.fileBangTotNghiep} /></Col>
                                        <Col md={6}><FieldDisplayFile label="3. Sơ yếu lý lịch (có dấu xác nhận của địa phương)" value={dataHoSo.fileSoYeuLyLich} /></Col>
                                        <Col md={6}><FieldDisplayFile label="4. Ảnh chân dung 3x4 và 4x6 (02 ảnh)" value={dataHoSo.fileAnhChanDung} /></Col>
                                        <Col md={6}><FieldDisplayFile label="5. Căn cước công dân photo" value={dataHoSo.fileAnhCccd} /></Col>
                                        <Col md={6}><FieldDisplayFile label="6. Minh chứng đóng lệ phí" value={dataHoSo.fileMinhChungLePhi} /></Col>
                                        {(dataHoSo.isDoiTuongMienGiam === true || dataHoSo.IsDoiTuongMienGiam === true) && (
                                            <Col md={6}><FieldDisplayFile label="7. Minh chứng miễn giảm" value={dataHoSo.fileMinhChungMienGiam || dataHoSo.FileMinhChungMienGiam} /></Col>
                                        )}
                                    </Row>
                                )}
                            </div>
                        </Tab>
                        
                        {dataKetQuaTuyenSinh && isDaGuiKetQua(actualTrangThaiGui) && (
                            <Tab eventKey="ket-qua-tuyen-sinh" title={<span><i className="fas fa-award mr-1"></i> Kết quả tuyển sinh</span>}>
                                <div className="bg-white p-4 border rounded mx-3 mb-4 mt-3" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                                    <h5 className="font-weight-bold mb-3 border-bottom pb-2 text-success">
                                        <i className="fas fa-award mr-2"></i> Quyết định kết quả tuyển sinh
                                    </h5>
                                    <div className="text-dark p-2" style={{ fontSize: '15px', lineHeight: '1.8' }}>
                                        <div className="mb-2"><strong>Trạng thái tuyển sinh:</strong> <span className="ml-2">{getKetQuaTuyenSinh(dataKetQuaTuyenSinh.ketQua || dataKetQuaTuyenSinh.KetQua)}</span></div>
                                        {loaiTuyenSinh === 0 && (
                                            <>
                                                <div className="mb-2"><strong>Số Quyết định công nhận NCS:</strong> <span className="ml-2">{dataKetQuaTuyenSinh.soQuyetDinh || dataKetQuaTuyenSinh.SoQuyetDinh || 'Chưa cấp'}</span></div>
                                                <div className="mb-2"><strong>Ngày quyết định:</strong> <span className="ml-2">{dataKetQuaTuyenSinh.ngayQuyetDinh || dataKetQuaTuyenSinh.NgayQuyetDinh ? moment(dataKetQuaTuyenSinh.ngayQuyetDinh || dataKetQuaTuyenSinh.NgayQuyetDinh).format('DD/MM/YYYY') : 'Chưa cấp'}</span></div>
                                                <div className="mb-2">
                                                    <strong>Cán bộ hướng dẫn - Đơn vị công tác - Vai trò cán bộ:</strong> 
                                                    <div className="mt-1 ml-3" style={{ lineHeight: '1.6' }}>
                                                        {(dataKetQuaTuyenSinh.canBoHuongDan || dataKetQuaTuyenSinh.CanBoHuongDan || '').split('\n').filter(Boolean).map((line, idx) => (
                                                            <div key={idx}>{idx + 1}. {line}</div>
                                                        ))}
                                                    </div>
                                                </div>
                                                <div className="mb-2"><strong>Hình thức đào tạo:</strong> <span className="ml-2">{getHinhThuc(dataKetQuaTuyenSinh.hinhThucDaoTaoId || dataKetQuaTuyenSinh.HinhThucDaoTaoId)}</span></div>
                                                <div className="mb-2"><strong>Quá trình đào tạo áp dụng theo Thông tư:</strong> <span className="ml-2">{dataKetQuaTuyenSinh.quyCheDaoTao || dataKetQuaTuyenSinh.QuyCheDaoTao || ''}</span></div>
                                                <div className="mb-2"><strong>Thời hạn đào tạo:</strong> <span className="ml-2">{getThoiHanDaoTao(dataKetQuaTuyenSinh.thoiHanDaoTao || dataKetQuaTuyenSinh.ThoiHanDaoTao)}</span></div>
                                                <div className="mb-2"><strong>Thời gian đào tạo:</strong> <span className="ml-2">{
                                                    (dataKetQuaTuyenSinh.tuNgay || dataKetQuaTuyenSinh.TuNgay ? moment(dataKetQuaTuyenSinh.tuNgay || dataKetQuaTuyenSinh.TuNgay).format('DD/MM/YYYY') : '...') 
                                                    + ' - ' + 
                                                    (dataKetQuaTuyenSinh.denNgay || dataKetQuaTuyenSinh.DenNgay ? moment(dataKetQuaTuyenSinh.denNgay || dataKetQuaTuyenSinh.DenNgay).format('DD/MM/YYYY') : '...')
                                                }</span></div>
                                                <div className="mb-2"><strong>Tên đề tài:</strong> <span className="ml-2">{dataKetQuaTuyenSinh.tenDeTai || dataKetQuaTuyenSinh.TenDeTai || ''}</span></div>
                                                
                                                <div className="mb-2 d-flex flex-wrap">
                                                    <div className="mr-5 mb-1"><strong>Mã ngành:</strong> <span className="ml-2">{dataHoSo.maNganh || dataHoSo.MaNganh || getMaNganh(dataHoSo.nganhId) || ''}</span></div>
                                                    <div className="mr-5 mb-1"><strong>Ngành:</strong> <span className="ml-2">{getNganh(dataHoSo.nganhId)}</span></div>
                                                    {dataHoSo.chuyenNganhId && (
                                                        <div className="mb-1"><strong>Chuyên ngành:</strong> <span className="ml-2">{getChuyenNganh(dataHoSo.chuyenNganhId)}</span></div>
                                                    )}
                                                </div>

                                                <div className="mt-4 mb-2"><strong>Thông báo nhập học:</strong></div>
                                                <div className="mb-3" dangerouslySetInnerHTML={{ __html: dataKetQuaTuyenSinh.thongBaoNhapHoc || dataKetQuaTuyenSinh.ThongBaoNhapHoc || '<span class="text-muted">Không có thông báo</span>' }}></div>
                                                
                                                <div className="mt-4 mb-2"><strong>File quyết định đính kèm:</strong></div>
                                                <div className="mb-3">
                                                    <FieldDisplayFile value={dataKetQuaTuyenSinh.fileQuyetDinh || dataKetQuaTuyenSinh.FileQuyetDinh} />
                                                </div>
                                            </>
                                        )}

                                        <div className="mt-4 mb-2"><strong>Ghi chú:</strong></div>
                                        <div className="mb-3" dangerouslySetInnerHTML={{ __html: dataKetQuaTuyenSinh.ghiChu || dataKetQuaTuyenSinh.GhiChu || '<span class="text-muted">Không có ghi chú</span>' }}></div>
                                    </div>
                                </div>
                            </Tab>
                        )}
                        
                        {hasLichSu && (
                            <Tab eventKey="lich-su-thay-doi" title={<span><i className="fas fa-history mr-1"></i> Lịch sử thay đổi</span>}>
                                <div className="bg-white p-4 border rounded mx-3 mb-4 mt-3" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                                    <LichSuThayDoiHoSoNCSTab hoSoId={hoSoId} />
                                </div>
                            </Tab>
                        )}
                        
                    </Tabs>
                    </>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default ThongTinNghienCuuSinhModal;
